import {decriptMessage} from "../../utils/SecureData";

export function getConfig() {
	let token = decriptMessage(sessionStorage.getItem("key_asl_to"));
	if (token) {
		return {
			headers: {
				Authorization: "Bearer " + token,
			},
		}
	} else return {}
}